import App from '@/app';
import faviconDefault from '@/assets/favicons/favicon-default.ico';
import { isProd } from '@/shared/lib/util/environment';
import { createRoot } from 'react-dom/client';

// Self-hosted Roboto (replaces the render-blocking fonts.googleapis.com/fonts.gstatic.com
// CDN <link> tags previously in index.ejs) — removes a cross-origin critical-path
// dependency that Lighthouse's Lantern throttling simulation was weighting heavily.
// Roboto is the app's default family (see shared/lib/styled/mui-theme.ts); these are the same
// weights dev requested from Google Fonts.
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';

// Montserrat names the patient on the identity line under the nav icons. Self-hosted for the same
// reason as Roboto -- no cross-origin request on the critical path -- and the variable cut rather
// than static weights, because that line asks for 550, which static faces would round to 600.
import '@fontsource-variable/montserrat';

import '@/shared/styles';

// The prod favicon is injected into the HTML at build time (see webpack/common.config.ts),
// so PROD renders the correct icon with no flash. For non-prod, swap to the default favicon.
if (!isProd()) {
  let faviconLink = document.querySelector<HTMLLinkElement>("link[rel~='icon']");
  if (!faviconLink) {
    faviconLink = document.createElement('link');
    faviconLink.rel = 'icon';
    document.head.appendChild(faviconLink);
  }
  faviconLink.href = faviconDefault;
}

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(<App />);
